module.exports = __webpack_public_path__ + "d009a609adde8e9b9b56721485d96d41.jpg";